<template>
    <footer class="footer">
        <!--<img class="footer__logo" src="/static/images/logo-white.svg" alt="El Niño" title="El Niño" height="32px">-->
        <div class="footer__text">
            <router-link :to="{ name: 'privacy' }" class="button--link">Privacy Policy</router-link>
            <router-link :to="{ name: 'terms-of-service' }" class="button--link">Terms of Service</router-link>
        </div>
    </footer>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class TheFooter extends Vue {
        name = 'the-footer';
    }

    Vue.component('the-footer', TheFooter);
</script>



// WEBPACK FOOTER //
// src/components/general/TheFooter.vue